import axios from 'axios';

    const  generateEwayBill = async (data) => {

        // https://api.whitebooks.in
        const url = "https://api.whitebooks.in/ewaybillapi/v1.03/ewayapi/genewaybill?email=ajith%40sninfoserv.com";

        const headers = {
            "ip_address": "157.51.64.247",
            "client_id": "EWBP968d3ddb-db10-425c-ba6e-248068d4035d",
            "client_secret": "EWBPd8df957e-f42b-4ec7-a74f-674e93ccd51f",
            "gstin": "33AAKCT9681P1ZC",
            "Content-Type": "application/json"
        };

        try {
            const response = await fetch(url, {
                "method": 'POST',
                "headers": headers,
                "body": JSON.stringify(data)
            });
            const result = await response.json();
            return result;
        } catch (error) {
            console.error("Failed to generate e-way bill:", error);
            return("Failed to generate e-way bill:", error);
        }
    };

    const createAuthToken = async () => {
      // https://api.whitebooks.in
      const url = "https://api.whitebooks.in/ewaybillapi/v1.03/authenticate?email=ajith%40sninfoserv.com&username=33AAKCT968_API_SNI&password=ewb4trc@SNI";

      const headers = {
        "ip_address": "157.51.52.164",
        "client_id": "EWBP968d3ddb-db10-425c-ba6e-248068d4035d",
        "client_secret": "EWBPd8df957e-f42b-4ec7-a74f-674e93ccd51f",
        "gstin": "33AAKCT9681P1ZC"
      };

      try {
        const response = await fetch(url, {
          "method": 'GET',
          "headers": headers
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
            return result;
      } catch (error) {
        console.error("Error during API call:", error);
      }
    };

    const createInvAuthToken = async () => {
      // https://api.whitebooks.in
      const url = "https://api.whitebooks.in/einvoice/authenticate?email=ajith@sninfoserv.com";

      const headers = {
        "ip_address": "145.79.210.131",
        "client_id": "EINPa9835fda-de97-42a4-8fde-384d5110fa7e",
        "client_secret": "EINP0e20b42d-123e-4306-8d85-c7afe6ab9373",
        "gstin": "33AAKCT9681P1ZC",
        "username": "33AAKCT968_API_SNI",
        "password": "ewb4trc@SNI",
      };

      try {
        const response = await axios.get(url, { headers });
        const result = response?.data;
            console.log(result);
            return result;
      } catch (error) {
        console.error("Error during API call:", error);
      }
    };

    const getGstDetails = async (token, gstIn) => {
      try {
        const response = await fetch(
          `https://api.whitebooks.in/einvoice/type/GSTNDETAILS/version/V1_03?param1=${gstIn}&email=ajith%40sninfoserv.com`,
          {
            "method": "GET",
            "headers": {
              "ip_address": "145.79.210.131",
              "client_id": "EINPa9835fda-de97-42a4-8fde-384d5110fa7e",
              "client_secret": "EINP0e20b42d-123e-4306-8d85-c7afe6ab9373",
              "username": "33AAKCT968_API_SNI",
              "auth-token": token,
              "gstin": "33AAKCT9681P1ZC"
            }
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log("GST Details:", data);

      } catch (error) {
        console.error("API Error:", error.message);
      }
    };

    const generateEinvoice = async (token, payload) => {

      const headers = {
        "Content-Type": "application/json",
        "ip_address": "145.79.210.131",
        "client_id": "EINPa9835fda-de97-42a4-8fde-384d5110fa7e",
        "client_secret": "EINP0e20b42d-123e-4306-8d85-c7afe6ab9373",
        "username": "33AAKCT968_API_SNI",
        "auth-token": token,
        "gstin": "33AAKCT9681P1ZC"
      };
      try {
        const response = await axios.post("https://api.whitebooks.in/einvoice/type/GENERATE/version/V1_03?email=ajith%40sninfoserv.com", payload, { headers });
            const result = response?.data;
            return result;
        } catch (error) {
            console.error("Failed to generate e-way bill:", error);
            return("Failed to generate e-way bill:", error);
        }
    };

    const cancelEinvoice = async (token, payload) => {
      try {
        const response = await fetch(
          "https://api.whitebooks.in/einvoice/type/CANCEL/version/V1_03?email=ajith%40sninfoserv.com",
          {
            "method": "POST",
            "headers": {
              "ip_address": "145.79.210.131",
              "client_id": "EINPa9835fda-de97-42a4-8fde-384d5110fa7e",
              "client_secret": "EINP0e20b42d-123e-4306-8d85-c7afe6ab9373",
              "username": "33AAKCT968_API_SNI",
              "auth-token": token,
              "gstin": "33AAKCT9681P1ZC"
            },
            "body": JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }

        const data = await response.json();
        return data;

      } catch (error) {
        console.error("Cancel API Error:", error.message);
        return("Cancel API Error:", error.message);
      }
    };


export default { generateEwayBill, createAuthToken, createInvAuthToken, getGstDetails, generateEinvoice, cancelEinvoice };